import { RootState } from '../../RootState';

const selectAuthenticatedUserId = (state: RootState): string | null =>
  state.auth.authenticatedUserId;

export default selectAuthenticatedUserId;
